<template>
  <div class="w-full bg-white p-4">
    <!-- stacked on phones, two across on tablets, four across on desktop -->
    <div class="flex flex-col md:flex-row md:flex-wrap" id="dashboard">
      <key-document v-if="vault.key_document" :vault="vault"></key-document>
      <file-and-tag
        v-if="!vault.key_document"
        :all-users="users"
        :vault="vault"
        v-is-authorized="{
          roles: [role],
          permissions: ['can_upload', 'can_file_document', 'can_tag_document'],
        }"
      ></file-and-tag>
      <discussions
        :vault-users="exceptCurrentUser()"
        v-is-authorized="{
          roles: [role],
          permissions: ['can_view_discussions'],
        }"
      ></discussions>
      <tasks
        :all-users="users"
        :vault-users="exceptCurrentUser()"
        v-is-authorized="{ roles: [role], permissions: ['can_view_tasks'] }"
        @task-marked-as-done="updateEvents"
      ></tasks>
      <events
        ref="events"
        :vault-users="users"
        :users="users"
        v-is-authorized="{ roles: [role], permissions: ['can_view_events'] }"
      ></events>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileAndTag from "../components/Vault/Dashboard/FileAndTag";
import KeyDocument from "../components/Vault/Dashboard/KeyDocument";
import Discussions from "../components/Vault/Dashboard/Discussions";
import Tasks from "../components/Vault/Dashboard/Tasks";
import Events from "../components/Vault/Dashboard/Events";

export default {
  components: {
    FileAndTag,
    KeyDocument,
    Discussions,
    Tasks,
    Events,
  },

  data() {
    return {
      users: [],
    };
  },

  mounted() {
    this.getVaultUsers();
  },

  methods: {
    updateEvents() {
      this.$refs.events.getEvents();
    },
    async getVaultUsers() {
      const lastPage = (await this.getUsers(1)).last_page;

      for(let i = 1; i <= lastPage; i++) {
        const response = await this.getUsers(i);
        this.users = [...this.users, ...response.data];
      }
    },

    getUsers(page = 1) {
      return axios
        .get(`/api/vaults/${this.$route.params.vault_id}/users?page=${page}`)
        .then(({ data }) => data);
    },

    exceptCurrentUser() {
      return _.filter(this.users, (user) => {
        return user.id != this.current_user.id;
      });
    },
  },

  computed: {
    ...mapGetters({
      vault: "getCurrentVault",
      current_user: "getUser",
      role: "getUserRole",
    }),
  },
};
</script>

<style>
</style>
